import { FEATURE_NAME } from './consts';

export const UPDATE_BRAND = `${FEATURE_NAME}/UPDATE_BRAND`;
